import { useTranslation } from 'react-i18next';

const SOURCES = [
  'ISTAT · 2024',
  'Open-Meteo · 1991–2020',
  'OECD Tax · 2024',
  'EF EPI · 2025',
  'WHO UHC · 2023',
  'IEP GPI · 2024',
];

export function TrustStrip() {
  const { t } = useTranslation();
  return (
    <section
      aria-label={t('home.trust.label')}
      className="border-y border-ink-100 bg-paper"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-6 py-5 sm:flex-row sm:items-center sm:gap-6">
        <span className="font-mono text-[11px] uppercase tracking-wider text-ink-500">
          {t('home.trust.label')}
        </span>
        <ul className="flex flex-wrap gap-x-5 gap-y-2">
          {SOURCES.map((src) => (
            <li
              key={src}
              className="font-mono text-[11px] tracking-wider text-ink-500"
            >
              {src}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
